import React, { useId } from 'react';
import { Checkbox } from './Checkbox';

export interface ICheckboxProps {
  isChecked: boolean;
  isIndeterminate?: boolean;
  onChange: (isChecked: boolean) => void;
  isDisabled?: boolean;
  isInvalid?: boolean;
  labelText: string;
}

export const CheckboxWithLabel: React.FC<ICheckboxProps> = (props) => {
  const { onChange, isChecked, isIndeterminate, isDisabled, isInvalid, labelText } = props;
  const id = useId();

  return (
    <label htmlFor={id} className="inline-flex items-center gap-2 py-1 text-sm text-fg cursor-pointer">
      <Checkbox
        isChecked={isChecked}
        isIndeterminate={isIndeterminate}
        onChange={onChange}
        id={id}
        isInvalid={isInvalid}
        isDisabled={isDisabled}
      />
      <span>{labelText}</span>
    </label>
  );
};
